import { FormattedMessage } from "react-intl";
import GoogleMap from "component/googleMap";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import OfficesList from "./offices-list";

export default function RegionalOfficesSection({
  dir,
  currentLocale,
  filters,
  onFilterChange,
  governorates,
  regionalOffices,
  branchLocations,
}) {
  return (
    <div className="contact-foot">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="contact-foot-info">
              <h5>
                <FormattedMessage id="regional-offices-accross-republican" />
              </h5>
            </div>
          </div>
          <div className="col-12 col-lg-6"></div>
          <div className="col-12 col-lg-6">
            <div className="contact-foot-info">
              <div className="item-form">
                <label>
                  <FormattedMessage id="country-or-district" />:
                  &nbsp;&nbsp;&nbsp;
                </label>
                <div className="dropdown">
                  <select
                    name="governorateId"
                    value={filters.governorateId ?? 0}
                    onChange={onFilterChange}
                  >
                    <option value={0}>
                      <FormattedMessage id="choose-location" />{" "}
                    </option>
                    {governorates.map(
                      ({ name, id, governorateTranslations }, index) => (
                        <option
                          key={index + 1}
                          value={id}
                          title={LabelLangString({
                            id: "name",
                            currentLocale,
                            defaultValue: name,
                            translations: governorateTranslations,
                          })}
                        >
                          <LabelLang
                            id="name"
                            defaultValue={name}
                            translations={governorateTranslations}
                          />
                        </option>
                      ),
                    )}
                  </select>
                  <div className="dropdown-icon" />
                </div>
              </div>
            </div>
            <div className="regional-offices">
              {regionalOffices.map(
                (
                  {
                    name,
                    mail,
                    address,
                    phoneNumber,
                    regionalOfficeTranslations,
                  },
                  index,
                ) => (
                  <div key={`coordinator-${index}`}>
                    <OfficesList
                      officeName={name}
                      mail={mail}
                      address={address}
                      phoneNumber={phoneNumber}
                      regionalOfficeTranslations={regionalOfficeTranslations}
                    />
                  </div>
                ),
              )}
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="map-c mb-5">
              <GoogleMap
                defaultCenterPoint={[27.442248, 29.770797]}
                isGovernateSelected={filters.governorateId !== null}
                zoom={filters.governorateId === null ? 6 : 15}
                geoLocationData={branchLocations}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
